import React, { Component } from 'react';
import { connect } from 'react-redux';

import ViewHeader from './view-header';
import ViewContent from './view-content';

// styling
import './style.css';

class FlagMetrics extends Component {
    render() {
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent />
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { authentication } = state;
    const { user } = authentication;
    return user;
}
export default connect(mapStateToProps)(FlagMetrics);


// WEBPACK FOOTER //
// ./src/views/flagMetrics/index.js